import { useEffect, useState } from "react"

import { FieldData, mapFilters } from "@/components/_Shared/FilterWrapper"

import { useFinanceReturnStatusQuery } from "@/hook/Finance/ReturnFunds/useFinanceReturnStatusQuery"
import { useFilterStorage } from "@/hook/useFilterStorage"

import { FINANCE_RETURN_FUNDS_KEY } from "@/types/IFinanceReturnFunds"
import { FilterField, FilterFieldType } from "@/types/ui"


export const useFinanceReturnFundsFilters = () => {
  const [filters, setFilters] = useState<FilterField[]>([])

  const { getFilter } = useFilterStorage({
    key: FINANCE_RETURN_FUNDS_KEY
  })

  const oldFilters: FieldData[] = getFilter()

  const { data: returnStatuses } = useFinanceReturnStatusQuery()

  useEffect(() => {
    let filters = [
      ...FinanceReturnFundsFilters,
      {
        text: "Статус",
        name: "Status",
        type: FilterFieldType.MultiSelect,
        values: returnStatuses
      }
    ]

    setFilters(filters)
  }, [returnStatuses])

  return mapFilters(filters, oldFilters)
}

const FinanceReturnFundsFilters: FilterField[] = [
  {
    text: "Дата",
    name: "Date",
    type: FilterFieldType.DateRange
  },
  {
    text: "Сумма",
    name: "sum",
    type: FilterFieldType.NumberWithOperator
  },
  {
    text: "Дата создания",
    name: "CreatedOn",
    type: FilterFieldType.DateRange
  }
]